import {actionIds, BaseAction} from "../common";

const setReportsQueryAction: (data: Record<string, string | number>) =>
    BaseAction = (data) => ({
    type: actionIds.SET_REPORTS_QUERY,
    payload: {...data}
});

export default setReportsQueryAction;